module.exports = __webpack_public_path__ + "fonts/playfair-display-v22-latin-regular.89eac9f9.woff";